import React, { useState } from 'react';
import { Button } from 'reactstrap';
import type { Condition } from '../../../../../models/companies/kyccs/condition';
import { EditNoteModal } from '../editNoteModal';

type Props = {
  condition: Condition;
};

export function ConditionResults(props: Props) {
  const [condition, setCondition] = useState<Condition>(props.condition);
  const [isOpenModal, setIsOpenModal] = useState<boolean>(false);

  const { kyccId, id } = condition;

  return (
    <div>
      <div className="d-flex align-items-center target mb-2">
        <span className="mr-3">{condition.name}</span>
        {kyccId != null && id != null && (
          <Button outline color="primary" onClick={() => setIsOpenModal(true)}>
            メモ
          </Button>
        )}
      </div>
      {condition.results.length > 0 && (
        <table className="table mb-4">
          <thead>
            <tr>
              <th>法人名</th>
              <th>住所</th>
              <th>電話番号</th>
              <th>団体名</th>
              <th>団体補足</th>
              <th>媒体名</th>
              <th>掲載日</th>
              <th>反社区分</th>
              <th>備考</th>
            </tr>
          </thead>
          <tbody>
            {condition.results.map((result, j) => (
              <tr key={j}>
                <td className="name">{result.name}</td>
                <td className="address">{result.address}</td>
                <td>{result.tel}</td>
                <td>{result.organizationName}</td>
                <td>{result.organizationSupple}</td>
                <td>{result.journalName}</td>
                <td>{result.reportedAt}</td>
                <td>{result.antisocialGroup}</td>
                <td>{result.note}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      {condition.results.length == 0 && <div>該当者はいませんでした</div>}
      {kyccId != null && id != null && (
        <EditNoteModal
          isOpen={isOpenModal}
          kyccId={kyccId}
          conditionId={id}
          note={condition.note || ''}
          onClose={() => setIsOpenModal(false)}
          onChangeNote={note => {
            setIsOpenModal(false);
            setCondition({ ...condition, note: note });
          }}
        />
      )}
    </div>
  );
}
